module.exports = __webpack_public_path__ + "media/application/images/icon_pragmatism-352525872e7523dccd765f8fd7267072.jpg";